var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"welcome-header"}},[_c('LoginVariableFont',{attrs:{"text":"Welcome"}}),_c('div',{class:{ animate: _vm.animate },attrs:{"id":"line-top"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }